export const HS_MESH_BATCH_OBJECTS_PER_ROW: number = 64;
export const HS_MESH_BATCH_PIXELS_PER_OBJECT: number = 5;
export const HS_MESH_BATCH_WINDOW_OBJECTS: number = 512;
